import styled from 'styled-components'

export const MainContainer = styled.div`
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16} ${props => props.theme.spacing.sp16}
    ${props => props.theme.spacing.sp8};
  background-color: ${props => props.backgroundColor};
  background-color: ${props => (props.index % 2 === 0 ? 'white' : '#F2F2F2')};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const SwitchAndLabelContainer = styled.div`
  display: flex;
  align-items: center;

  & > p {
    margin-left: -${props => props.theme.spacing.sp16}!important;
  }
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};

  label {
    margin-right: 0;
  }

  & > button:last-child {
    margin-left: -15px;
  }
`
export const TagsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
`
